<template>
<div class="overlay">
    <div :class="fullscreen ? 'content' : 'content-not-fullscreen'">
        <slot />
         <img @click="close" class="close-cross" src="@/assets/SVG/cross-partners.svg" alt="">
    </div>

</div>
</template>
<script>
export default {
  name: 'reg-modal',
  props: {
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style >
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}
.content {
    position: absolute;
    border-radius: 10px;
    top: 30%;
    width: 90%;
    left: 5%;
    background-color: white
}
.content-not-fullscreen {
    position:relative;
    border-radius: 10px;
    padding: 60px 30px 38px 30px;
    min-width: 400px;
    background-color: white
}
.close-cross {
    position: absolute;
    top: 20px;
    right: 30px;
    cursor: pointer;
}
</style>
